import React, { useState, useEffect } from "react";
import ReusableTable from "../../components/Employee/Table";
import DateRange from "../../components/Employee/AttendanceSummary/DateRange";
import { formatDateOnly, getDateMonthsAgo } from "../../util/common";
import TextInput from "../../components/Reusable/TextInput";
import SelectInput from "../../components/Reusable/SelectInput";
import DateInput from "../../components/Reusable/DateInput";
import { useNavigate } from "react-router-dom";

function OfficialBusinessLayout() {
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const [filter, setFilter] = useState({
    DateFrom: formatDateOnly(getDateMonthsAgo(1)),
    DateTo: formatDateOnly(new Date()),
    OrderBy: "desc",
  });

  const handleOnPageChange = (pageIndex, pageSize) => {
    setPagination({
      page: pageIndex + 1,
      pageSize,
    });
  };

  const tableColumns = [
    { accessorKey: "AttendanceDate", header: "Code" },
    { accessorKey: "AttendanceDate", header: "Employee" },
    { accessorKey: "AttendanceDate", header: "OB Date From" },
    { accessorKey: "AttendanceDate", header: "OB Date To" },
    { accessorKey: "AttendanceDate", header: "OB Time From" },
    { accessorKey: "AttendanceDate", header: "OB Time To" },
    { accessorKey: "TimeIn", header: "Approver" },
    { accessorKey: "TimeOut", header: "Approved" },
    { accessorKey: "TotalHours", header: "Approved At" },
  ];

  return (
    <div className="overtime-form-container">
      <h2>Employee Official Business</h2>
      <form className="overtime-form">
        <div className="form-column">
          <SelectInput
            label="Employee Name"
            choices={[{ id: 1, name: "Jimboy Reyes" }]}
            onChange={(val) => {}}
          />
          <SelectInput
            label="Department"
            choices={[{ id: 1, name: "HR & Admin" }]}
            onChange={(val) => {}}
          />
          <SelectInput
            label="Approval Status"
            choices={[
              { id: 1, name: "Approved" },
              { id: 2, name: "Pending" },
              { id: 3, name: "Cancelled" },
              { id: 4, name: "Rejected" },
            ]}
            onChange={(val) => {}}
          />
        </div>

        <div className="form-column">
          <DateInput label="Date From" onChange={(val) => {}} />
          <DateInput label="Date To" onChange={(val) => {}} />
        </div>

        <div className="form-group full-width file-upload-section">
          <div className="attendance-filters">
            <div className="attendance-records">
              <ReusableTable
                data={[]}
                columns={tableColumns}
                mode="server"
                initialPageSize={pagination.pageSize}
                onPageChange={handleOnPageChange}
                pageCount={pageCount}
                page={pagination.page - 1}
                pageSize={pagination.pageSize}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default OfficialBusinessLayout;
